import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement, forwardRef } from 'rax';
import View from '../view';
const List = (props, ref) => {
    const { children, prefix = 'mt-', className } = props, others = __rest(props, ["children", "prefix", "className"]);
    return (<View {...others} ref={ref} className={classNames(`${prefix}list`, className)}>
      {children}
    </View>);
};
List.displayName = 'List';
export default forwardRef(List);
